import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const StarryBackground = () => {
  const containerRef = useRef(null);

  // 生成固定數量的星星數據，避免重新渲染時閃爍
  const stars = React.useMemo(() => {
    return Array.from({ length: 100 }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 2 + 1,
      delay: Math.random() * 5,
      duration: Math.random() * 3 + 2,
    }));
  }, []);

  const shootingStars = React.useMemo(() => {
    return Array.from({ length: 4 }).map((_, i) => ({
      id: i,
      top: Math.random() * 60,
      delay: Math.random() * 15,
      duration: Math.random() * 2 + 3,
    }));
  }, []);

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {/* 靜態漸變背景 */}
      <div className="absolute inset-0 bg-gradient-to-b from-dark-900 via-dark-800 to-dark-900" />
      
      {/* 星星 */}
      {stars.map((star) => (
        <motion.div
          key={star.id}
          className="absolute bg-white rounded-full"
          style={{
            left: `${star.x}%`,
            top: `${star.y}%`,
            width: star.size,
            height: star.size,
          }}
          animate={{ opacity: [0, 1, 0] }}
          transition={{
            duration: star.duration,
            repeat: Infinity,
            delay: star.delay,
            ease: "easeInOut"
          }}
        />
      ))}

      {/* 流星 */}
      {shootingStars.map((star) => (
        <motion.div
          key={`shooting-${star.id}`}
          className="absolute h-[2px] w-[100px] bg-gradient-to-r from-white to-transparent opacity-0"
          style={{
            top: `${star.top}%`,
            left: '-10%',
            rotate: '-45deg',
            boxShadow: '0 0 10px 2px rgba(255, 255, 255, 0.1)'
          }}
          animate={{
            x: ['0vw', '120vw'],
            opacity: [0, 1, 0],
          }}
          transition={{
            duration: star.duration,
            repeat: Infinity,
            delay: star.delay,
            ease: "linear",
            repeatDelay: Math.random() * 10 + 5
          }}
        />
      ))}
    </div>
  );
};

export default StarryBackground;